export default __webpack_public_path__ + "static/media/map-tile-bank.b6145286.svg";